import { LISTING_TYPE } from '../constants/listing'
import { TAB } from './ReturnsAnalysis'
import {
  FIELD as TABLE_SORT_FIELD
} from './ReturnSummaries/SummariesTable/SummariesTable'

export const GA_CLICK_ACTION = {
  TAB: 'TAB',
  LISTING_OPTION: 'LISTING_OPTION',
  TABLE_SORT: 'TABLE_SORT',
  TABLE_LINK_LISTING_COUNT: 'TABLE_LINK_LISTING_COUNT'
}

const GA_KEY = {
  LISTING_OPTION_ALL: 'LISTING_OPTION_ALL',
  LISTING_OPTION_ORDER: 'LISTING_OPTION_ORDER',
  TAB_RETURNS: 'TAB_RETURNS',
  TAB_SUMMARIES: 'TAB_SUMMARIES',
  TABLE_SORT_AMOUNT: 'TABLE_SORT_AMOUNT',
  TABLE_SORT_QUANTITY: 'TABLE_SORT_QUANTITY',
  TABLE_SORT_LISTING_COUNT: 'TABLE_SORT_LISTING_COUNT',
  TABLE_LINK_LISTING_COUNT: 'TABLE_LINK_LISTING_COUNT'
}

const GA_KEY_MAP = {
  [GA_KEY.LISTING_OPTION_ALL]: 'return_allgd',
  [GA_KEY.LISTING_OPTION_ORDER]: 'return_specgd',
  [GA_KEY.TAB_RETURNS]: 'return_trendtab',
  [GA_KEY.TAB_SUMMARIES]: 'return_reasontab',
  [GA_KEY.TABLE_SORT_AMOUNT]: 'return_reason_orderamt',
  [GA_KEY.TABLE_SORT_QUANTITY]: 'return_reason_ordercnt',
  [GA_KEY.TABLE_SORT_LISTING_COUNT]: 'return_reason_ordergd',
  [GA_KEY.TABLE_LINK_LISTING_COUNT]: 'return_reason_gdlist'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TAB: {
      const map = {
        [TAB.RETURNS]: GA_KEY.TAB_RETURNS,
        [TAB.SUMMARIES]: GA_KEY.TAB_SUMMARIES
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.LISTING_OPTION: {
      const map = {
        [LISTING_TYPE.ALL]: GA_KEY.LISTING_OPTION_ALL,
        [LISTING_TYPE.ORDER]: GA_KEY.LISTING_OPTION_ORDER
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [TABLE_SORT_FIELD.AMOUNT]: GA_KEY.TABLE_SORT_AMOUNT,
        [TABLE_SORT_FIELD.QUANTITY]: GA_KEY.TABLE_SORT_QUANTITY,
        [TABLE_SORT_FIELD.LISTING_COUNT]: GA_KEY.TABLE_SORT_LISTING_COUNT
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK_LISTING_COUNT:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
